const USERS_BASE_PATH = "users"
export const USERS_SIGNIN_PATH = `${USERS_BASE_PATH}/sign_in`
